module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "collectSupplierContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    店铺收藏 \n    \n    "), (_vm.isManage) ? _c('div', {
    staticClass: "cancelManageCollect"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "取消管理"
    },
    on: {
      "click": function($event) {
        return _vm.manageCollect(false)
      }
    }
  })]) : _c('div', {
    staticClass: "manageCollect"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "收藏管理"
    },
    on: {
      "click": function($event) {
        return _vm.manageCollect(true)
      }
    }
  })]), _vm._v(" "), (_vm.isManage) ? _c('div', {
    staticClass: "delCollect",
    on: {
      "click": _vm.delCollect
    }
  }, [_c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s4fa98fed29b1ec7c9825589935fabd4a.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelName"
  }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (_vm.isManage) ? _c('div', {
    staticClass: "allSelect"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckboxChange
    },
    model: {
      value: (_vm.isAll),
      callback: function($$v) {
        _vm.isAll = $$v
      },
      expression: "isAll"
    }
  }), _c('span', {
    staticClass: "labelName",
    on: {
      "click": _vm.allSelect
    }
  }, [_vm._v("全选")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    key: _vm.collectSupplierIndex,
    staticClass: "collectSupplierList"
  }, [(_vm.supplierList.length > 0) ? _c('ul', _vm._l((_vm.supplierList), function(item, i) {
    return _c('li', {
      key: 'goods_' + i,
      staticClass: "collectSupplier"
    }, [(item.supplierLogo) ? _c('img', {
      attrs: {
        "src": item.supplierLogo
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "supplierName"
    }, [_vm._v(_vm._s(item.supplierName))]), _vm._v(" "), (item.labels) ? _c('div', {
      staticClass: "supplierLabel"
    }, _vm._l((item.labels), function(item, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(item))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "supplierBtn",
      on: {
        "click": function($event) {
          return _vm.toSupplier(item)
        }
      }
    }, [_vm._m(0, true)]), _vm._v(" "), (_vm.isManage) ? _c('div', {
      staticClass: "selectSupplier"
    }, [_c('el-checkbox', {
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "delSupplier"
    }, [_c('img', {
      attrs: {
        "src": "https://file-sz.fjjykj.com.cn/Supply/s7700d715392bcc97de0073f0ed076c23.png"
      },
      on: {
        "click": function($event) {
          return _vm.delCollectItem(item.supplierId)
        }
      }
    })])])
  }), 0) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "http://file-sz.fjjykj.com.cn/Supply/se919e00d1de3930d887d67eebd282e15.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s3ddb52f022fb50f6fe82592174971b0d.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e0e55a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CollectSupplierList.vue
// module id = 770
// module chunks = 2